import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-single-load-grid',
    template: `
    @if (rowData?.length && columnDefinitions?.length) {
    <app-ng-table-results
      class="flex-1 min-h-0 block"
      [tableName]="tableName"
      [tableData]="rowData"
      [columnDefinitions]="columnDefinitions"
      [selectedOperation]="selectedLoad"
      [apiCollapseType]="apiCollapseType"
      [hangerLiftoffForce]="hangerLiftoffForce"
      [shearPinRating]="shearPinRating"
      [upwardMovementLimit]="upwardMovementLimit"
      [downwardMovementLimit]="downwardMovementLimit"
      [hollidayStressRatio]="hollidayStressRatio"
      [virtualScroll]="true"
      [autoHeight]="false"
      [lengthUnit]="lengthUnit"
      [tableHeight]="'flex'"
      [mode]="mode"
    />
    }
  `,
    styles: [':host { display: flex; flex-direction: column; height: 100%; min-height: 0; overflow: hidden; } :host([hidden]) { display: none !important; }'],
    standalone: false
})
export class SingleLoadGridComponent {

  @Input()
  public gridName: string;

  @Input()
  public tableName:string;

  @Input()
  public rowData: any[];

  @Input()
  public apiCollapseType: string;

  @Input()
  public hangerLiftoffForce: number;

  @Input()
  public shearPinRating: number;

  @Input()
  public upwardMovementLimit: number;

  @Input()
  public downwardMovementLimit: number;

  @Input()
  public hollidayStressRatio: number | null;

  @Input()
  public selectedLoad: string;

  @Input()
  public mode: string;

  @Input()
  public columnDefinitions: { field: string, header: string, valueFormatter(params: any): string }[];

  @Input()
  public lengthUnit: string = 'ft';
}

